"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNoMonetizationProperty = exports.noMonetizationPropertyDefinition = void 0;
exports.noMonetizationPropertyDefinition = {
    view: {
        label: 'No monetization',
        hint: 'Want to disable ads?',
    },
    constraints: [],
    type: 'boolean',
    multiple: false,
    name: 'no-monetization',
    default: false,
};
const isNoMonetizationProperty = (prop) => {
    return prop.name === exports.noMonetizationPropertyDefinition.name;
};
exports.isNoMonetizationProperty = isNoMonetizationProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm8tbW9uZXRpemF0aW9uLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvbm8tbW9uZXRpemF0aW9uLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsZ0NBQWdDLEdBQUc7SUFDOUMsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLGlCQUFpQjtRQUN4QixJQUFJLEVBQUUsc0JBQXNCO0tBQzdCO0lBQ0QsV0FBVyxFQUFFLEVBQUU7SUFDZixJQUFJLEVBQUUsU0FBUztJQUNmLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLGlCQUFpQjtJQUN2QixPQUFPLEVBQUUsS0FBSztDQUNpQixDQUFBO0FBSTFCLE1BQU0sd0JBQXdCLEdBQUcsQ0FBQyxJQUFrQixFQUFrQyxFQUFFO0lBQzdGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyx3Q0FBZ0MsQ0FBQyxJQUFJLENBQUE7QUFDNUQsQ0FBQyxDQUFBO0FBRlksUUFBQSx3QkFBd0IsNEJBRXBDIn0=